import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const SkeletonFloorFinder = ({ steps = [] }) => {
  return (
    <div className="finder-wrapper">
      <div className="finder-main">
        <h2 className="finder-title"> <Skeleton width={300} height={30} /> </h2>
        <div className="track-desk">
          <div className="finder-grid">
            {Array(6)
              .fill(0)
              .map((_, idx) => (
                <div key={idx} className="finder-grid-item">
                  <Skeleton width={200} height={200} />
                  <Skeleton width={80} height={20} style={{ marginTop: 10 }} />
                </div>
              ))}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 20,
          }}
          >
          <Skeleton width={100} height={40} />
          <Skeleton width={100} height={40} />
        </div>
      </div>

      {/* Skeleton for stepper */}

      <div className="stepper-right" style={{ marginTop: 20 }}>
        {Array(steps.length || 5)
          .fill(0)
          .map((_, idx) => (
            <Skeleton key={idx} width={20} height={20} style={{ marginBottom: 10 }} />
          ))}
      </div>
    </div>
  );
};
export default SkeletonFloorFinder;
